import React, { Component } from "react";
import styles from "./Presentation.local.scss";
import { getUserNameForAvatar } from "Utils";
import { TTP_API_URL } from "Config";
import { connect } from "react-redux";
import _ from "i18n";

class ShowComments extends Component {
  componentDidMount() {
    this.handlePlayAllAudioComment();
  }

  handlePlayAllAudioComment = () => {
    const { comments } = this.props;

    let mySoundArray = [];
    var mySoundArrayPos = 0;
    let audioComments = comments.filter(({ type }) => type === "AUDIO");
    audioComments.map((item, i) => {
      mySoundArray.push(document.getElementById(`audio-${item.id}`));
    });
    if (audioComments.length > 0) {
      document.getElementById(`audio-${audioComments[0].id}`).play();
      mySoundArrayPos = 0;
      this.startSoundTimer(mySoundArray, mySoundArrayPos);
    }
  };

  startSoundTimer = (mySoundArray, mySoundArrayPos) => {
    var mySoundTimer = setInterval(() => {
      if (
        mySoundArray[mySoundArrayPos].currentTime >=
        mySoundArray[mySoundArrayPos].duration
      ) {
        if (mySoundArrayPos < mySoundArray.length - 1) {
          mySoundArrayPos += 1;
          mySoundArray[mySoundArrayPos].play();
        } else {
          clearInterval(mySoundTimer);
        }
      }
    }, 10);
  };

  render() {
    const { comments, user } = this.props;
    return (
      <div className={styles.modal_content}>
        {comments.map((item, i) => {
          const fullName = item.user.firstName + " " + item.user.lastName;
          const myName = item.user.lastName + " (" + _("me") + ")";
          const avatar = [];
          if (item.user.avatarUrl !== undefined) {
            // let url = `http://local.api.tamtam.pro/${item.user.avatar}`;
            avatar.push(<img src={item.user.avatarUrl} alt={""} />);
          } else if (item.user.avatar) {
            let url = `${TTP_API_URL}/${item.user.avatar}`;
            avatar.push(<img src={url} alt={""} />);
          } else {
            avatar.push(
              <span className={styles.avatar} style={{ marginLeft: "24%}" }}>
                {getUserNameForAvatar(item.user.firstName, item.user.lastName)}
              </span>
            );
          }
          return (
            <div className={`row ${styles.comment_frame}`}>
              <div className={styles.avatar}>{avatar[0]}</div>
              <div className={styles.content}>
                <div className={styles.owner}>
                  {user &&
                  user.firstName === item.user.firstName &&
                  user.lastName === item.user.lastName
                    ? myName
                    : fullName}
                </div>
                {item.type === "AUDIO" ? (
                  <audio
                    id={`audio-${item.id}`}
                    controls
                    src={item.content ? item.content.path : null}
                  />
                ) : (
                  <div className={styles.comment}>{item.content}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  user: state.auth.user,
  lng: state.params.lng
});

export default connect(mapStateToProps)(ShowComments);



// WEBPACK FOOTER //
// ./src/components/Presentation/ShowComments.js